// 问卷问题类型
export const WENJUAN_TYPE = {
  RADIO: 1,
  CHECKBOX: 2,
  TEXTAREA: 3,
  SCORE: 4,
};

// 方案秀类型
const USER_SCHEME_OPERATION_OBJ = {
  SCHEME: 2020092201,
  COMPANY: 2020092203,
  SYSTEM: 2020092204,
};
export const USER_SCHEME_OPERATIONS = USER_SCHEME_OPERATION_OBJ;

// 方案秀类型
const SCHEME_CATEGORYS_TYPE = {
  SCHEME: 0,
  COMPANY: 1,
  SYSTEM: 2,
  COLLECTION: 3,
};
export const SCHEME_TYPE = SCHEME_CATEGORYS_TYPE;

// 方案秀分类
export const SCHEME_CATEGORYS = [
  {
    name: '方案秀',
    type: SCHEME_CATEGORYS_TYPE.SCHEME,
    operation: USER_SCHEME_OPERATION_OBJ.SCHEME,
  },
  {
    name: '企业模板',
    type: SCHEME_CATEGORYS_TYPE.COMPANY,
    operation: USER_SCHEME_OPERATION_OBJ.COMPANY,
  },
  {
    name: '系统模板',
    type: SCHEME_CATEGORYS_TYPE.SYSTEM,
    operation: USER_SCHEME_OPERATION_OBJ.SYSTEM,
  },
  {
    name: '我的收藏',
    type: SCHEME_CATEGORYS_TYPE.COLLECTION,
  },
];
